import { createContext, useContext } from "react";

import type { AppLocale, MessageCatalog, MessageKey } from "./types";

export interface LocaleContextValue {
  locale: AppLocale;
  catalog: MessageCatalog;
  t: (key: MessageKey) => string;
}

export const LocaleContext = createContext<LocaleContextValue | null>(null);

export function useLocale() {
  const context = useContext(LocaleContext);
  if (!context) throw new Error("useLocale requires LocaleProvider");
  return context;
}
